import request from '@wearetla/tla-essentials-tools/utilities/request';
import coreSiteServices from '../../core/services/site';
import { createI18nInstance } from '/utilities/i18n';

// Dummy Data
import staticLocations from '/data/locations';

const siteServices = {
	...coreSiteServices,
	getLocations: () => {
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve(
					staticLocations.map((l) => ({
						...l,
						value: l.slug,
						label: l.shortTitle,
					}))
				);
			}, 2);
		});
	},
	// Amateur Band Form
	submitAmateurBandForm: (fields) => {
		const { t } = createI18nInstance();
		return new Promise((resolve, reject) => {
			request.post(
				`client/amateur-band-form`,
				{
					...fields,
				},
				(payload, status, request) => {
				if (status === 200) {
					resolve(
						request?.data?.meta?.messages || {
							success: t('Başvurunuz başarıyla iletildi, teşekkür ederiz.'),
						}
					);
				} else {
					reject(
						request?.data?.meta?.messages ||
							t('Başvurunuz gönderilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.')
					);
				}
			});
		});
	},
};

export default siteServices;
